/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AppInfoDto } from './AppInfoDto';
import type { ClusterConfigDto } from './ClusterConfigDto';
import type { ClusterParticipantConfigDto } from './ClusterParticipantConfigDto';
import type { EnvVar } from './EnvVar';
import type { PostgresConfigDto } from './PostgresConfigDto';
import type { ValidatorAuthDto } from './ValidatorAuthDto';
import type { ValidatorDbConfigDto } from './ValidatorDbConfigDto';

export type ValidatorDto = {
    auth?: ValidatorAuthDto;
    clusterConfig: ClusterConfigDto;
    clusterParticipantConfig: ClusterParticipantConfigDto;
    customAuth?: boolean;
    envVars?: Array<EnvVar>;
    imageRepo: string;
    imageTag: string;
    name: string;
    onboardingSecret?: string;
    participant: AppInfoDto;
    phase?: ValidatorDto.phase;
    /**
     * @deprecated
     */
    postgresPassword: string;
    /**
     * @deprecated
     */
    postgresUser: string;
    databaseConfig?: ValidatorDbConfigDto;
    postgresConfig?: PostgresConfigDto;
    effectiveDatabaseConfig?: ValidatorDbConfigDto;
    nodeIdentifier?: boolean;
    databaseConfigValid?: boolean;
};

export namespace ValidatorDto {

    export enum phase {
        COMPLETED = 'COMPLETED',
        PENDING = 'PENDING',
        RUNNING = 'RUNNING',
    }


}

